module.exports = __webpack_public_path__ + "img/title-contact.58e15498.svg";